import { useTranslation } from 'react-i18next';

export default function StatsBar() {
  const { t } = useTranslation();

  const stats = [
    { value: t('statsBar.experience'), label: t('statsBar.experienceLabel'), desc: t('statsBar.experienceDesc') },
    { value: t('statsBar.satisfaction'), label: t('statsBar.satisfactionLabel'), desc: t('statsBar.satisfactionDesc') },
    { value: t('statsBar.freeQuotes'), label: t('statsBar.freeQuotesLabel'), desc: t('statsBar.freeQuotesDesc') },
    { value: t('statsBar.local'), label: t('statsBar.localLabel'), desc: t('statsBar.localDesc') },
  ];

  return (
    <div className="w-full bg-background-100 border-t-4 border-primary-500">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row divide-y sm:divide-y-0 sm:divide-x divide-foreground-50/10">
        {stats.map((stat, index) => (
          <div key={index} className="flex-1 flex flex-col items-center justify-center text-center px-6 py-8">
            <div className="flex items-end gap-0.5">
              <span className="text-4xl md:text-5xl font-extrabold text-accent-500">{stat.value}</span>
            </div>
            <p className="text-primary-500 font-semibold text-sm mt-1">{stat.label}</p>
            <p className="text-foreground-200 text-xs mt-1 leading-snug max-w-[160px]">{stat.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}